import React, { useState  , useEffect} from 'react';
import { Link } from 'react-router-dom';
import "./BookList.css";
import coverImg from "../../images/cover_not_found.jpg";

const Book = (book) => {
  const [showButtons, setShowButtons] = useState(false);
  //searchCriteria.);
  let linktoDeta = "";
  
  if(book.type === "book"){
    linktoDeta = `/book/${book.id}`;
  }else{

    linktoDeta = `/journal/${book.category}/${book.id}`;

  }
  const handleMouseEnter = () => {
    setShowButtons(true);
  };

  const handleMouseLeave = () => {
    setShowButtons(false);
  };

  const handleCoverClick = () => {
    if (!showButtons) {
      setShowButtons(true);
    }
  };

  function isImageUrl(url) {
    try {
      // Check if the URL is a string
      if (typeof url !== 'string') {
       return 
      }
      // The regular expression checks for image file extensions at the end of the string
      // Extensions included: .jpg, .jpeg, .png, .gif (case-insensitive)
      return /\.(jpg|jpeg|png|gif)$/i.test(url);
    } catch (error) {
      console.error(error.message);
      // Return false on error, could be logged or handled as needed
      return false;
    }
  }

return (

    <div className='book-item flex flex-column flex-sb' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
      <div className='book-item-img' onClick={handleCoverClick}>
      <img src={isImageUrl(book.cover_img)? book.cover_img : coverImg } loading='lazy' alt="" />
        {showButtons && (
          <div className="cover-buttons">
            <Link to={linktoDeta} className="book-details-btn">تفاصيل </Link>
          {book.book_url && /^(http:\/\/|https:\/\/)/.test(book.book_url) ? (
          <div className="">
            
          <Link 
            to={`/view/${book.id}`} 
            state={{ book: book }} 
            className="book-details-btn">
              اقرأ الآن
          </Link>
          
            </div>
          ) : null}
          </div>
        )}
      </div>
      <div className='book-item-info text-center'>
        <div className='book-item-info-item title fw-7 fs-18'>
          <Link style={{color:"black"}} to={linktoDeta}>{book.title}</Link>
          {book.parentType === "All" && (
          <div className='book-item-info-item author fs-15'>
          <span className='text-italic'>
          {book.type === "book" ? "كتاب" : "مجلة"}
            </span>
            </div> 
              )}
        </div>
        
        {/* {book.authors && (
        <div className='book-item-info-item author fs-15'>
          <span className='text-capitalize fw-7'>تأليف:</span>
          <span>{book.authors}</span>
        </div>
         )} */}
        
        {book?.visit ? (

        <div className='book-item-info-item publish-year fs-15'>
          <span className='text-capitalize fw-7'> زيارات: </span>
          <span className='text-italic'>
          {new Intl.NumberFormat('ar-EG', { useGrouping: false }).format(parseInt(book?.visit))}
        </span>
        </div>
        ): null}
      </div>
    </div>

  )
}

export default Book;